import { css, forBrands, useTheme } from '@core-ui/react-stitch';

const brDefaultStyleOverrides = () => {
  const theme = useTheme();

  return (
    forBrands(theme, {
      br: css`
        span.product-price__highlight--brff, div.product-price__highlight--brff {
          color: ${theme.color.b1};
        }
      `,
      brfs: css`
        span.product-price__highlight--brff, div.product-price__highlight--brff {
          color: ${theme.color.b1};
        }
      `,
    })
  );
};

export default brDefaultStyleOverrides;
